module.exports = __webpack_public_path__ + "img/3-19.56f5e1fe.jpg";